export default {
  methods: {
    addBackgroundPlugin(chart) {
      chart.addPlugin({
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, args, options) => {
          const {ctx} = chart;
          ctx.save();
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = options.color || '#ffffff';
          ctx.fillRect(0, 0, chart.width, chart.height);
          ctx.restore();
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/charts.js